import { useEffect, useState } from 'react';
import { Spin, Result, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { httpService } from '../utils/apiService';
import { Interweave } from 'interweave';
import { extractBodyContent } from '../utils/utils';

const TermsAndConditions = () => {
  const { t } = useTranslation(['settings', 'common']);
  const navigate = useNavigate();
  const [termsHtml, setTermsHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        setLoading(true);
        const response = await httpService.get('setting/list');
        const settings = response.data.data;
        setTermsHtml(settings?.termsHtml || '');
        setError(false);
      } catch (err) {
        console.error('Error fetching terms and conditions:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Result
          status="error"
          title={t('common:fetchError')}
          subTitle={t('common:failedToLoadTerms')}
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              {t('common:tryAgain')}
            </Button>
          }
        />
      </div>
    );
  }

  if (!termsHtml) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Result
          status="info"
          title={t('termsTitle')}
          subTitle={t('common:noTermsAvailable')}
          extra={
            <Button type="primary" onClick={() => navigate('/')}>
              {t('common:backToLogin')}
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div className="min-h-[80vh] overflow-y-auto">
      <div className="max-h-[80vh] overflow-y-auto py-4 px-4">
        <div className="prose prose-sm max-w-none">
          <Interweave 
            className="text-sm leading-relaxed"
            content={extractBodyContent(termsHtml)}
            allowList={['p', 'div', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'strong', 'b', 'em', 'i', 'u', 'a', 'br', 'hr', 'table', 'thead', 'tbody', 'tr', 'td', 'th', 'blockquote', 'code', 'pre', 'img']}
            attributes={{
              'a': ['href', 'class', 'style', 'target'],
              'img': ['src', 'alt', 'class', 'style', 'width', 'height'],
              '*': ['class', 'style']
            }}
          />
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <Button 
            type="primary" 
            size="large"
            onClick={() => navigate('/')}
          >
            {t('common:backToLogin')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions; 